import { css } from "@emotion/react"

const removeHighlight = '-webkit-tap-highlight-color: transparent'
const systemScrollResetCss = css`
    overflow-x: hidden;
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
`



const webkit = {
  removeHighlight,
  systemScrollResetCss
}

export default webkit
